.inputContainer {
  :global {
    .ant-input-group-wrapper {
      & .ant-input {
        border: none;
        border-radius: 8px;
        padding: 8px 12px;
      }

      & .ant-input-group-addon {
        padding: 0;
        border: none;
        border-radius: 8px;
      }
    }
  }

  .input {
    border-radius: 8px;
    border: 1px solid var(--bc-color-border);
  }

  .error {
    border: 1px solid var(--bc-color-error);

    &:hover, &:active, &:focus {
      border: 1px solid var(--bc-color-error);
    }
  }

  .errorContainer {
    margin-top: 6px;
    font-size: 12px;
    line-height: 12px;
    color: var(--bc-color-error);

    .icon {
      font-size: 13px;
      color: var(--bc-color-error);
      margin-right: 5px;
    }
  }

  .label {
    display: block;
    color: var(--bc-color-text-secondary);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 12px;
    margin-bottom: 9px;
  }
}

.filter {
  .content {
    &::before {
      display: none;
    }
    :global {
      .ant-select-content-item-prefix {
        display: none;
      }
    }
  }

  :global {
    .ant-select {
      width: 60px !important;
    }
  }
}
